import { z } from "zod";
import { authenticatedFastApiAxiosInstance as http } from "@/lib/data/http";
import {
  fileContentSchema,
  fileContentPageSchema,
} from "@/lib/data/schemas/file-content";
export async function getFileContent(id: string) {
  return fileContentSchema.parse((await http.get(`file-contents/${id}`)).data);
}
export async function getFileContentPages(
  id: string,
  processingId: string,
  cursor?: string,
) {
  return z
    .object({
      fileContentId: z.string(),
      processingId: z.string(),
      data: z.array(fileContentPageSchema),
      nextCursor: z.string().nullable(),
    })
    .parse(
      (
        await http.get(`file-contents/${id}/pages`, {
          params: { processingId, cursor, limit: 30 },
        })
      ).data,
    );
}
export async function getFileContentSource(
  id: string,
  processingId: string,
  pageNumber: number,
) {
  return z
    .object({
      data: z.array(
        z.object({
          pageNumber: z.number(),
          url: z.string().url(),
          contentType: z.string(),
        }),
      ),
    })
    .parse(
      (
        await http.get(`file-contents/${id}/source-pages`, {
          params: { processingId, pageNumber },
        })
      ).data,
    );
}
